import { render, staticRenderFns } from "./FornecedoresForm.vue?vue&type=template&id=66349121&scoped=true&"
import script from "./FornecedoresForm.vue?vue&type=script&lang=js&"
export * from "./FornecedoresForm.vue?vue&type=script&lang=js&"
import style0 from "./FornecedoresForm.vue?vue&type=style&index=0&id=66349121&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66349121",
  null
  
)

export default component.exports